import { CLIENT_PAGE_LOADING } from 'redux/modules/page/actions/types';

export const clientPageLoading = () => ({
  type: CLIENT_PAGE_LOADING,
});
